document.addEventListener("DOMContentLoaded", () => {
  const toggle = (
    trigger: HTMLElement,
    arrow: HTMLElement,
    content: HTMLElement,
    open: boolean
  ) => {
    const screenWidth = window.innerWidth;
    if (open) {
      content.classList.replace("max-h-0", "max-h-max");
      if (screenWidth >= 768) {
        content.classList.add("mt-4");
        trigger.classList.replace("pb-10", "pb-0");
      }
      trigger.classList.add("opened-line");
      arrow.classList.add("rotate-90");
    } else {
      content.classList.replace("max-h-max", "max-h-0");
      if (screenWidth >= 768) {
        content.classList.remove("mt-4");
        trigger.classList.replace("pb-0", "pb-10");
      }
      trigger.classList.remove("opened-line");
      arrow.classList.remove("rotate-90");
    }
  };

  Array.from(document.querySelectorAll<HTMLElement>(".toggle")).forEach(
    (el: HTMLElement) => {
      const trigger = el.querySelector<HTMLElement>(".toggle-trigger");
      const arrow = el.querySelector<HTMLElement>(".toggle-arrow");
      const content = el.querySelector<HTMLElement>(".toggle-content");

      trigger!.addEventListener("click", () => {
        toggle(
          trigger!,
          arrow!,
          content!,
          !content?.classList.contains("max-h-max")
        );
      });
    }
  );
});

// partial header footer
async function loadFragment(id: string, url: string): Promise<void> {
  const response = await fetch(url);
  const text = await response.text();
  const element = document.getElementById(id);
  if (element) {
    element.innerHTML = text;
  }
}

document.addEventListener("DOMContentLoaded", async () => {
  await loadFragment("header", "src/partials/header.html");
  await loadFragment("footer", "src/partials/footer.html");
  await loadFragment("popUpWrapper", "src/partials/popUp.html");
  // Теперь, когда загружен header, можно выполнять скрипты для dropdown и меню
  initHeaderScripts();

  // Отримуємо посилання на елементи
  const enterCabinetButton = document.querySelector(
    ".btn-enter-cabinet"
  ) as HTMLElement;
  const findPsychoButton = document.querySelector(
    ".btn-find-psycho"
  ) as HTMLElement;

  // Перевіряємо, чи body має клас "for_psychotherapists-body"
  if (document.body.classList.contains("for_psychotherapists-body")) {
    // Показуємо кнопку "btn-enter-cabinet" та приховуємо "btn-find-psycho"
    if (enterCabinetButton) enterCabinetButton.style.display = "flex";
    if (findPsychoButton) findPsychoButton.style.display = "none";
  } else {
    // В іншому випадку приховуємо "btn-enter-cabinet" та показуємо "btn-find-psycho"
    if (enterCabinetButton) enterCabinetButton.style.display = "none";
    if (findPsychoButton) findPsychoButton.style.display = "flex";
  }
});

// Функция, перенесенная из header.ts
function initHeaderScripts() {
  const dropdownContainers = Array.from(
    document.querySelectorAll(".dropdownContainer")
  ) as HTMLElement[];

  dropdownContainers.forEach((container) => {
    const dropdownButton = container.querySelector(
      ".dropdownButton"
    ) as HTMLElement;
    const dropdownMenu = container.querySelector(
      ".dropdownMenu"
    ) as HTMLElement;
    // arrow down
    const arrowDown = container.querySelector(".arrowDown") as HTMLElement;

    dropdownButton?.addEventListener("click", (event) => {
      arrowDown?.classList.toggle("rotate");
      dropdownMenu?.classList.toggle("hidden");
      event.stopPropagation();
    });

    document.addEventListener("click", (event) => {
      const targetElement = event.target as Node;
      const isClickInside = container.contains(targetElement);

      if (!isClickInside) {
        arrowDown?.classList.remove("rotate");
        dropdownMenu?.classList.add("hidden");
      }
    });
  });

  const menuButton = document.getElementById("menuButton") as HTMLButtonElement;
  const menuItems = document.getElementById("menuItems") as HTMLElement;
  const closeMenu = document.getElementById("closeMenu") as HTMLElement;

  menuButton?.addEventListener("click", () => {
    menuItems?.classList.toggle("hidden"); // Toggle visibility of menu items
  });

  closeMenu?.addEventListener("click", () => {
    menuItems?.classList.add("hidden");
  });

  document.addEventListener("click", (event) => {
    if (
      !menuButton?.contains(event.target as Node) &&
      !menuItems?.contains(event.target as Node)
    ) {
      menuItems?.classList.add("hidden");
    }
  });

  // smooth scrol
  const toReviewsBtn = document.querySelector(".to-reviews") as HTMLElement;
  const reviewsSection = document.getElementById("reviews") as HTMLElement;

  if (toReviewsBtn && reviewsSection) {
    toReviewsBtn.addEventListener("click", (event) => {
      event.preventDefault();

      reviewsSection.scrollIntoView({
        behavior: "smooth",
      });
    });
  }

  // pop-ups
  const closePopUpBtnList = document.querySelectorAll(".pop-up-close-btn");
  const popUpWRP = document.querySelector(
    ".pop-up-overlay-wrapper"
  ) as HTMLElement;
  const showEnterPopUp = document.querySelector(
    ".show-enter-pop-up"
  ) as HTMLElement;
  const forgotPassword = document.querySelector(
    ".forgot-password"
  ) as HTMLElement;
  const enterPopUp = document.getElementById("popUpSignIn") as HTMLElement;
  const popRecoveryPassword = document.getElementById(
    "popRecoveryPassword"
  ) as HTMLElement;

  showEnterPopUp?.addEventListener("click", () => {
    popUpWRP?.classList.add("show-popup");
    enterPopUp?.classList.add("show-popup");
  });

  forgotPassword?.addEventListener("click", () => {
    const popUps = document.querySelectorAll(
      ".popup"
    ) as NodeListOf<HTMLElement>;

    popUps.forEach((popup) => {
      popup.classList.remove("show-popup");
    });
    popRecoveryPassword?.classList.add("show-popup");
  });

  // close all pop-ups
  closePopUpBtnList.forEach((closePopUpBtn) => {
    closePopUpBtn.addEventListener("click", () => {
      popUpWRP?.classList.remove("show-popup");
      const popUps = document.querySelectorAll(
        ".popup"
      ) as NodeListOf<HTMLElement>;

      popUps.forEach((popup) => {
        popup.classList.remove("show-popup");
      });
    });
  });

  // show / hide password in inputs
  const togglePasswordButtons: NodeListOf<HTMLElement> =
    document.querySelectorAll(".toggle-password");

  togglePasswordButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const passwordInput: HTMLInputElement | null =
        button.previousElementSibling as HTMLInputElement;
      if (passwordInput) {
        const type =
          passwordInput.getAttribute("type") === "password"
            ? "text"
            : "password";
        passwordInput.setAttribute("type", type);
        // Optionally change the icon
        button.classList.toggle("show");
      }
    });
  });
}
// init header end

// Отримуємо елементи сердечка та числа з DOM
const heartIcon = document.getElementById("heart-icon");
const likeCountElement = document.querySelector("#like-count");

// Перевіряємо, чи елементи існують
if (heartIcon && likeCountElement) {
  // Встановлюємо початковий стан лайка
  let isLiked = false;
  let likeCount = parseInt(likeCountElement.textContent || "0", 10);

  // Додаємо слухач подій для кліку
  heartIcon.addEventListener("click", () => {
    isLiked = !isLiked; // Перемикаємо стан лайка

    // Оновлюємо іконку залежно від стану
    if (isLiked) {
      heartIcon.setAttribute("src", "./assets/article/HeartFill.svg");
      heartIcon.setAttribute("alt", "Liked");
      likeCount += 1; // Збільшуємо кількість лайків
    } else {
      heartIcon.setAttribute("src", "./assets/article/HeartStraight.svg");
      heartIcon.setAttribute("alt", "Not liked");
      likeCount -= 1; // Зменшуємо кількість лайків
    }

    // Оновлюємо текст числа поруч
    likeCountElement.textContent = likeCount.toString();
  });
} else {
  console.error("Елемент сердечка або числа лайків не знайдено в DOM");
}

// blog code
function initRubrica() {
  const categoryDropdownWrp = Array.from(
    document.querySelectorAll(".category-dropdown-wrp")
  ) as HTMLElement[];

  categoryDropdownWrp.forEach((container) => {
    const categoryButton = container.querySelector(
      ".all-category"
    ) as HTMLElement;
    const categoryDropdown = container.querySelector(
      ".category-dropdown"
    ) as HTMLElement;
    // arrow down
    const arrowRubrika = container.querySelector(
      ".arrowRubrika"
    ) as HTMLElement;

    categoryButton?.addEventListener("click", (event) => {
      arrowRubrika?.classList.toggle("rotate");
      categoryDropdown?.classList.toggle("hidden");
      event.stopPropagation();
    });

    document.addEventListener("click", (event) => {
      const targetElement = event.target as Node;
      const isClickInside = container.contains(targetElement);

      if (!isClickInside) {
        arrowRubrika?.classList.remove("rotate");
        categoryDropdown?.classList.add("hidden");
      }
    });
  });
}

// Пагінація
const totalPages = 10; // Загальна кількість сторінок
const visiblePages = 4; // Скільки сторінок показувати одночасно

const paginationContainer = document.getElementById(
  "pagination"
) as HTMLUListElement;

const renderPagination = (currentPage: number) => {
  paginationContainer.innerHTML = ""; // Очищуємо попередній контент

  const createPageItem = (page: number, isActive: boolean = false) => {
    const li = document.createElement("li");
    li.className = `page-item ${isActive ? "active" : ""}`;
    li.textContent = page.toString();
    li.addEventListener("click", () => {
      renderPagination(page);
    });
    return li;
  };

  const createDots = () => {
    const li = document.createElement("li");
    li.className = "page-item dots";
    li.textContent = "...";
    return li;
  };

  // Перша сторінка
  paginationContainer.appendChild(createPageItem(1, currentPage === 1));

  if (currentPage > 3) {
    // Додаємо "...", якщо далеко від початку
    paginationContainer.appendChild(createDots());
  }

  // Центральні сторінки
  const startPage = Math.max(2, currentPage - 1);
  const endPage = Math.min(totalPages - 1, currentPage + 1);
  for (let page = startPage; page <= endPage; page++) {
    paginationContainer.appendChild(createPageItem(page, currentPage === page));
  }

  if (currentPage < totalPages - 2) {
    // Додаємо "...", якщо далеко від кінця
    paginationContainer.appendChild(createDots());
  }

  // Остання сторінка
  if (totalPages > 1) {
    paginationContainer.appendChild(
      createPageItem(totalPages, currentPage === totalPages)
    );
  }
};

// Ініціалізація пагінації, якщо на сторінці є клас .blog-body та ширина екрану більше 991px
const initializePagination = () => {
  if (document.querySelector(".blog-body") && window.innerWidth > 990) {
    renderPagination(1);
    paginationContainer.style.display = "flex";
  } else {
    paginationContainer.style.display = "none";
  }
};

// Слухач зміни розміру екрану
window.addEventListener("resize", initializePagination);

// Первинна ініціалізація
initializePagination();

document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector(".article-body")) {
    // скрол меню на сторінці Стаття
    const menuArticlesItems =
      document.querySelectorAll<HTMLLIElement>(".article-plan li");
    const headings = document.querySelectorAll<HTMLHeadingElement>("h2");
    const articlePlan =
      document.querySelector<HTMLUListElement>(".article-plan");
    const article = document.querySelector<HTMLElement>("article");
    const generalArticlePlan = document.querySelector<HTMLElement>(
      ".general-article-plan"
    );
    const articleMain = document.querySelector<HTMLElement>(
      ".general-article-main"
    );

    menuArticlesItems.forEach((item, index) => {
      item.addEventListener("click", (event) => {
        event.preventDefault();

        // Знімаємо клас active з усіх пунктів
        menuArticlesItems.forEach((menuItem) => {
          menuItem.classList.remove("active");
          const link = menuItem.querySelector("a");
          if (link) link.classList.remove("active");
        });

        // Додаємо клас active до обраного пункту
        item.classList.add("active");
        const link = item.querySelector("a");
        if (link) link.classList.add("active");

        // Скролимо до відповідного підзаголовку
        const heading = headings[index];
        if (heading) {
          heading.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    });

    // Додатково: Активуємо пункт у меню при скролі сторінки
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = Array.from(headings).indexOf(
            entry.target as HTMLHeadingElement
          );
          if (entry.isIntersecting && index !== -1) {
            // Знімаємо клас active з усіх пунктів
            menuArticlesItems.forEach((menuItem) => {
              menuItem.classList.remove("active");
              const link = menuItem.querySelector("a");
              if (link) link.classList.remove("active");
            });

            // Додаємо клас active до відповідного пункту
            const activeItem = menuArticlesItems[index];
            activeItem.classList.add("active");
            const link = activeItem.querySelector("a");
            if (link) link.classList.add("active");
          }
        });
      },
      { threshold: 0.6 } // Точка спрацювання: 60% видимості заголовку
    );

    headings.forEach((heading) => observer.observe(heading));
  }

  initRubrica();
});

// Додаємо стилі для "липкого меню"
// const style = document.createElement("style");
// style.textContent = `
//   .general-article-plan.sticky {
//     position: fixed;
//     width: 100%;
//     background-color: white; /* Змінити залежно від дизайну */
//     box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
//     transition: top 0.2s ease-out;
//   }
// `;
// document.head.appendChild(style);
